import { type ReactNode } from 'react';
import { cn } from '@/nucleo/utilitarios';

export interface Annotation {
  /** Texto da anotação numerada. */
  text: string;
}

/**
 * Exemplo real com anotações numeradas — substitui explicações em código,
 * garantindo representação visual também no PDF.
 */
export function AnnotatedExample({
  children,
  annotations,
  title,
  className,
}: {
  children: ReactNode;
  annotations: Annotation[];
  title?: string;
  className?: string;
}) {
  return (
    <div className={cn('grid gap-4 lg:grid-cols-[1fr_260px] break-inside-avoid', className)}>
      <div className="min-w-0 rounded-xl border border-border bg-background p-5">
        {title && (
          <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-3">
            {title}
          </p>
        )}
        {children}
      </div>
      <ol className="space-y-2">
        {annotations.map((a, i) => (
          <li key={a.text} className="flex gap-2.5">
            <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary text-[10px] font-bold text-primary-foreground">
              {i + 1}
            </span>
            <span className="text-xs text-muted-foreground leading-relaxed">{a.text}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
